<template>
  <v-container
    fluid
    class="pa-0 login-background"
    :style="{ backgroundImage: 'url(' + $cdnEndpoint + 'img/login/login_background.jpg)' }"
    style="text-align: center;"
  >
    <div class="content-area">
      <Announcement class="mb-5" :announcement="announcementData" />
      <v-layout align-center column justify-centers class="bg-color-white login-form-area">
        <WarningText :is-show="!isAllowedBrowserAccess" :warning-text="browserEnvironmentAlert" />

        <v-flex class="mt-5 mb-5">
          <LabelEmailInput id="email" v-model="email" v-on:keyup.enter.native="valid ? submitLogin() : false" style="margin-left: 7px;" />
          <LabelPasswordInput
            id="password"
            v-model="password"
            v-on:keyup.enter.native="valid ? submitLogin() : false"
            style="margin-left: 7px;"
          />
          <Button :width="313" :height="40" primary :disabled="!valid" :loading="loginLoading" @click.native="valid ? submitLogin() : false"
            >ログイン</Button
          >
        </v-flex>
      </v-layout>
    </div>
    <LabelDialog v-model="isAccountLockWarningDialogOpen" :message-pre-wrap="false" warning>
      <template #dialog-title>
        アカウントロック
      </template>

      <template #dialog-message>
        ただ今一時的にアカウントをロックしています。
        <br />20分ほど経ってから再度お試しください。
        <p class="mt-4">
          ご登録時のメールアドレスとパスワードをもう一度お確かめいただき、パスワードをお忘れの方は、パスワード再設定手続きを行ってください。
        </p>
      </template>

      <template #dialog-action>
        <v-layout column>
          <v-layout justify-end>
            <Button width="100" primary @click.native="isAccountLockWarningDialogOpen = !isAccountLockWarningDialogOpen">閉じる </Button>
          </v-layout>
        </v-layout>
      </template>
    </LabelDialog>

    <LabelDialog v-model="isAccountLockDialogOpen" :message-pre-wrap="false" error>
      <template #dialog-title>
        アカウントロック
      </template>

      <template #dialog-message>
        ログインの失敗が一定数に達したため、アカウントをロックしました。
        <br />アカウント復旧についてのお問い合わせは、以下のアドレスまでお願いいたします。
        <p class="mt-4">メール：support@lecheck.jp</p>
      </template>

      <template #dialog-action>
        <v-layout column>
          <v-layout justify-end>
            <Button width="100" primary @click.native="isAccountLockDialogOpen = !isAccountLockDialogOpen">閉じる </Button>
          </v-layout>
        </v-layout>
      </template>
    </LabelDialog>
  </v-container>
</template>

<script>
import { VAlert } from 'vuetify/lib';

// API
import UserScenario from '@/api/account/user/scenario';

import WarningText from '@/components/_atoms/WarningText.vue';
import Button from '@/components/_atoms/buttons/Button.vue';
import EmailInput from '@/components/_atoms/inputs/EmailInput.vue';
import LabelEmailInput from '@/components/_molecules/LabelEmailInput.vue';
import LabelPasswordInput from '@/components/_molecules/LabelPasswordInput.vue';
import LabelDialog from '@/components/_molecules/LabelDialog.vue';
import Announcement from '@/components/_organisms/Announcement.vue';

import errormsg from '@/constants/errormsg';

export default {
  name: 'LoginForLefiling',
  components: {
    VAlert,
    WarningText,
    LabelEmailInput,
    LabelPasswordInput,
    Button,
    EmailInput,
    LabelDialog,
    Announcement
  },
  data() {
    return {
      email: '',
      password: '',
      showPassword: false,
      loginLoading: false,
      accountLockValid: false,
      isAccountLockWarningDialogOpen: false,
      isAccountLockDialogOpen: false,
      browserEnvironmentAlert: errormsg.BROWSER_ENV_ALERT,
      announcementData: {
        show: false,
        items: []
      },
      clientId: this.$route.query.client_id ? this.$route.query.client_id : null,
      redirect: this.$route.query.redirect_uri ? this.$route.query.redirect_uri : null,
      page: this.$route.query.page ? this.$route.query.page : null,
      state: this.$route.query.state ? this.$route.query.state : null
    };
  },
  computed: {
    isAllowedBrowserAccess: function() {
      return this.$store.getters['userAgent/getIsAllowedBrowserAccess'];
    },
    valid: function() {
      return this.email && this.password;
    }
  },
  methods: {
    submitLogin() {
      this.loginLoading = true;
      UserScenario.loginForLeFILING(this.email, this.password)
        .then(res => {
          let refreshToken = res.data.data.refreshToken;
          if (this.redirect) {
            window.location.href = this.redirect + '?client_id=' + this.clientId + '&state=' + this.state + '&code=' + refreshToken;
          }
        })
        .catch(error => {
          if (error.response.status === 403 && error.response.data.message === 'AccountLock') {
            this.isAccountLockWarningDialogOpen = true;
          } else if (error.response.status === 418) {
            this.isAccountLockDialogOpen = true;
          } else {
            this.$store.dispatch('message/setErrorMessage', {
              message: error.response.data.error ? error.response.data.error : 'ログインに失敗しました'
            });
          }
        })
        .finally(_ => {
          this.loginLoading = false;
        });
    }
  }
};
</script>

<style scoped>
.v-toolbar {
  display: none;
}

.content-area {
  position: absolute;
  left: 50%;
  top: calc(50% - 50px);
  transform: translate(-50%, -50%);
}

/* Form */
.login-form-area {
  width: 426px;
  border-radius: 5px;
  box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.16);
  border: solid 1px #ced6e0;
  margin-left: auto;
  margin-right: auto;
  text-align: left;
}
.v-alert.v-alert {
  border: none !important;
  margin-bottom: 25px;
}

.login-background {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  background-size: cover;
}
</style>



// WEBPACK FOOTER //
// src/pages/LoginForLefiling.vue